export const PARTNER_STATUS_ACTIVE = 1;

export const RESET_ERROR = 'partnerFees/RESET_ERROR';

export const FETCH_PARTNER_FEE = 'partnerFees/FETCH_PARTNER_FEE';
export const FETCH_PARTNER_FEE_SUCCESS = 'partnerFees/FETCH_PARTNER_FEE_SUCCESS';
export const FETCH_PARTNER_FEE_FAIL = 'partnerFees/FETCH_PARTNER_FEE_FAIL';

export const FETCH_PARTNER_FEES_BY_CONTRACT_ID = 'partnerFees/FETCH_PARTNER_FEES_BY_CONTRACT_ID';
export const FETCH_PARTNER_FEES_BY_CONTRACT_ID_SUCCESS = 'partnerFees/FETCH_PARTNER_FEES_BY_CONTRACT_ID_SUCCESS';
export const FETCH_PARTNER_FEES_BY_CONTRACT_ID_FAIL = 'partnerFees/FETCH_PARTNER_FEES_BY_CONTRACT_ID_FAIL';

export const FETCH_PARTNER_FEES_BY_SERVICE_PARTNER_ID = 'partnerFees/FETCH_PARTNER_FEES_BY_SERVICE_PARTNER_ID';
export const FETCH_PARTNER_FEES_BY_SERVICE_PARTNER_ID_SUCCESS = 'partnerFees/FETCH_PARTNER_FEES_BY_SERVICE_PARTNER_ID_SUCCESS';
export const FETCH_PARTNER_FEES_BY_SERVICE_PARTNER_ID_FAIL = 'partnerFees/FETCH_PARTNER_FEES_BY_SERVICE_PARTNER_ID_FAIL';

export const FETCH_PARTNER_FEES_BY_SERVICE_OFFICE_ID = 'partnerFees/FETCH_PARTNER_FEES_BY_SERVICE_OFFICE_ID';
export const FETCH_PARTNER_FEES_BY_SERVICE_OFFICE_ID_SUCCESS = 'partnerFees/FETCH_PARTNER_FEES_BY_SERVICE_OFFICE_ID_SUCCESS';
export const FETCH_PARTNER_FEES_BY_SERVICE_OFFICE_ID_FAIL = 'partnerFees/FETCH_PARTNER_FEES_BY_SERVICE_OFFICE_ID_FAIL';

export const FETCH_PARTNER_FEES_BY_PARTNER_ID = 'partnerFees/FETCH_PARTNER_FEES_BY_PARTNER_ID';
export const FETCH_PARTNER_FEES_BY_PARTNER_ID_SUCCESS = 'partnerFees/FETCH_PARTNER_FEES_BY_PARTNER_ID_SUCCESS';
export const FETCH_PARTNER_FEES_BY_PARTNER_ID_FAIL = 'partnerFees/FETCH_PARTNER_FEES_BY_PARTNER_ID_FAIL';
export const CLEAR_PARTNER_FEES_BY_PARTNER_ID = 'partnerFees/CLEAR_PARTNER_FEES_BY_PARTNER_ID';

export const CREATE_CONTRACT_SERVICE_SUCCESS = 'partnerFees/CREATE_CONTRACT_SERVICE_SUCCESS';
export const CREATE_CONTRACT_SERVICE_FAIL = 'partnerFees/CREATE_CONTRACT_SERVICE_FAIL';
export const UPDATE_CONTRACT_SERVICE_SUCCESS = 'partnerFees/UPDATE_CONTRACT_OFFICE_SUCCESS';
export const UPDATE_CONTRACT_SERVICE_FAIL = 'partnerFees/UPDATE_CONTRACT_OFFICE_FAIL';
export const DELETE_CONTRACT_SERVICE_SUCCESS = 'partnerFees/DELETE_CONTRACT_SERVICE_SUCCESS';
export const DELETE_CONTRACT_SERVICE_FAIL = 'partnerFees/DELETE_CONTRACT_SERVICE_FAIL';

export const CREATE_CONTRACT_LEGAL_FEE_SUCCESS = 'partnerFees/CREATE_CONTRACT_LEGAL_FEE_SUCCESS';
export const CREATE_CONTRACT_LEGAL_FEE_FAIL = 'partnerFees/CREATE_CONTRACT_LEGAL_FEE_FAIL';
export const UPDATE_CONTRACT_LEGAL_FEE_SUCCESS = 'partnerFees/UPDATE_CONTRACT_LEGAL_FEE_SUCCESS';
export const UPDATE_CONTRACT_LEGAL_FEE_FAIL = 'partnerFees/UPDATE_CONTRACT_LEGAL_FEE_FAIL';
export const DELETE_CONTRACT_LEGAL_FEE_SUCCESS = 'partnerFees/DELETE_CONTRACT_LEGAL_FEE_SUCCESS';
export const DELETE_CONTRACT_LEGAL_FEE_FAIL = 'partnerFees/DELETE_CONTRACT_LEGAL_FEE_FAIL';
